import { Component, ViewEncapsulation } from '@angular/core';
import { ApiService } from '../core/services';
import { State } from '../core/store/reducers/index';
import { OnInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { Store } from '@ngrx/store';
import { AddBarrier } from '../core/store/actions/barriers.actions';
import * as mapboxgl from 'mapbox-gl';

@Component({
  selector: 'amber-spotter',
  template: require('./amber-spotter.component.html'),
  styles: [require('./amber-spotter.component.scss')],
  encapsulation: ViewEncapsulation.None
})
export class AmberSpotterComponent implements OnInit {
  // @ViewChild(AgmInfoWindow) infoWindow: AgmInfoWindow;
  zoom = 3;

  // Default position vaguely central Europe
  latitude = 54;
  longitude = 10;

  showMarker = false;
  markerLat = null;
  markerLng = null;

  comment = '';
  submitting = false;
  submitted = false;

  map: mapboxgl.Map;
  popup: mapboxgl.Popup;


  constructor(
    private api: ApiService,
    private store: Store<State>
  ) { }

  ngOnInit() {
    (mapboxgl as any).accessToken = 'pk.eyJ1IjoibmF0YXBwIiwiYSI6ImNqZHg1MXZndDNxM2UzM3FwdnRsdW96cWIifQ.szIwfw6q7QTADsLCQXCKiw';
    // this.barriers$ = this.store.select(item => item.barriers.barriers);
    this.map = new mapboxgl.Map({
      container: 'barrier-spotter',
      style: 'mapbox://styles/mapbox/satellite-v9',
      center: [this.longitude, this.latitude],
      zoom: this.zoom,
      scrollZoom: true,
      attributionControl: true,
    });

    this.map.on('load', () => {
      const tileUrl = 'https://maps.coreo.io/projects/barrier-tracker/source/r30/{z}/{x}/{y}.mvt';

      this.map.addSource('records', {
        type: 'vector',
        tiles: [
          tileUrl
        ]
      });

      this.map.addLayer({
        id: 'possible-barriers',
        type: 'circle',
        source: 'records',
        'source-layer': `records-30`,
        paint: {
          'circle-color': '#6aac87',
          'circle-radius': {
            base: 1.5,
            stops: [
              [12, 5],
              [18, 10]
            ]
          },
          'circle-stroke-width': 1,
          'circle-stroke-color': '#000',
        }
      });

      this.map.on('click', (e: mapboxgl.MapMouseEvent) => {
        this.markerLng = e.lngLat.lng;
        this.markerLat = e.lngLat.lat;
        if (this.popup) {
          this.popup.setLngLat(e.lngLat);
        } else {
          this.showPopup();
        }
      });
    });
  }

  showPopup() {
    const container = document.createElement('div');
    container.classList.add('spotter-options');

    const textarea = document.createElement('textarea');
    textarea.setAttribute('placeholder', 'Comment (optional)...');

    const buttons = document.createElement('div');
    buttons.classList.add('spotter-buttons');
    const cancel = document.createElement('button');
    cancel.classList.add('secondary');
    cancel.textContent = 'Cancel';
    cancel.addEventListener('click', () => this.closePopup());

    const submit = document.createElement('button');
    submit.textContent = 'Submit barrier';
    submit.addEventListener('click', () => {
      cancel.setAttribute('disabled', 'disabled');
      submit.setAttribute('disabled', 'disabled');
      textarea.setAttribute('disabled', 'disabled');
      const comment = textarea.value;

      this.api.spotBarrier(this.markerLat, this.markerLng, comment).subscribe(() => {
        this.store.dispatch(new AddBarrier(this.markerLat, this.markerLng));

        const successContainer = document.createElement('div');
        successContainer.classList.add('submitted');
        const successMessage1 = document.createElement('p');
        successMessage1.textContent = 'Thank you for your submission!';
        const successMessage2 = document.createElement('p');
        successMessage2.textContent = 'Nearby? Go out and check with the Barrier Tracker app.';
        const successButton = document.createElement('a');
        successButton.classList.add('button_theme');
        successButton.setAttribute('href', '#download');
        successButton.textContent = 'Download Barrier Tracker';
        successContainer.appendChild(successMessage1);
        successContainer.appendChild(successMessage2);
        successContainer.appendChild(successButton);

        const successWrapper = document.createElement('div');
        successWrapper.classList.add('spotter-options');
        successWrapper.appendChild(successContainer);

        this.popup.setDOMContent(successWrapper);

        // <div>
        // <p>Thank you for your submission!</p>
        // <p>Nearby? Go out and check with the Barrier Tracker app.</p>
        // <button (click)="download()">Download Barrier Tracker</button>
        // </div>

        this.submitted = true;
      }, () => {
        this.closePopup();
      });
    });

    buttons.appendChild(cancel);
    buttons.appendChild(submit);

    container.appendChild(textarea);
    container.appendChild(buttons);

    this.popup = new mapboxgl.Popup({
      closeOnClick: false
    })
      .setLngLat([this.markerLng, this.markerLat])
      .setDOMContent(container)
      .addTo(this.map);

    this.popup.on('close', () => {
      this.popup = null;
    });
  }

  closePopup() {
    if (this.popup) {
      this.popup.remove();
      this.popup = null;
    }
  }

  download() {
    location.href = '#download';
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/amber-spotter/amber-spotter.component.ts